import { gql } from '@apollo/client';

export const QUERY = gql`
  query Forms($organizationId: Int!) {
    forms(organizationId: $organizationId) {
      id
      name
      openAt
      closeAt
      createdAt
      isRetired
      isOpen
      isReg2
      participantCount
      registeredTodayCount
      collected
      balance
      season {
        id
        name
        tsDivisionId
        program_id
        program {
          id
          name
        }
      }
    }
  }
`;
